import Vue from 'vue'
import Vuex from 'vuex'
// import moment from 'moment'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    initializing: false,
    initialized: false,
		selectedLanguage: localStorage.getItem('language') || 'it-IT',
		dictionaries: {
      "it-IT": {},
      "en-EN": {},
      "es-ES": {},
      "fr-FR": {},
      "de-DE": {}
    }
  },
  mutations: {
    updateLanguage (state, { value }) {
      state.selectedLanguage = value
      localStorage.setItem('language', value)
    },
    registerDictionaries (state, { value }) {
      if (value) {
        localStorage.setItem('dictionaries', JSON.stringify(value))
      } else {
        value = JSON.parse(localStorage.getItem('dictionaries'))
      }
      Vue.set(state, 'dictionaries', value)
    }
    /* readFromLocalStorage (state) {
      if (!state.initializing && !state.initialized) {
        state.initializing = true
        try {
          let lan = localStorage.getItem('language')
          if (lan) {
            state.selectedLanguage = lan
            console.log('language is ' + lan)
          }
        } catch (e) {
          console.warn('language', e)
        }
        state.initialized = true
      }
    } */
  },
  actions: {
    /*increment (context) {
      context.commit('increment');
    }*/
  }
})
